// extracted by mini-css-extract-plugin
export default {"atlasContainer":"atlasesGrid_atlasContainer__vCVcR"};